import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_SIMCARDS_LIST,
  GET_SIMCARDS_LIST_SUCCESS,
  GET_SIMCARDS_LIST_ERROR,
  ADD_SIMCARDS,
  ADD_SIMCARDS_SUCCESS,
  ADD_SIMCARDS_ERROR,
  IMPORT_SIMCARDS,
  IMPORT_SIMCARDS_SUCCESS,
  IMPORT_SIMCARDS_ERROR,
  GET_SIMCARD,
  GET_SIMCARD_SUCCESS,
  GET_SIMCARD_ERROR,
  UPDATE_SIMCARD,
  UPDATE_SIMCARD_SUCCESS,
  UPDATE_SIMCARD_ERROR,
  SYNCHRONIZE_SIMCARDS,
  SYNCHRONIZE_SIMCARDS_SUCCESS,
  SYNCHRONIZE_SIMCARDS_ERROR,
  ACTIVATE_SIMCARDS,
  ACTIVATE_SIMCARDS_SUCCESS,
  ACTIVATE_SIMCARDS_ERROR,
  LINK_SIMCARD_DEVICE,
  LINK_SIMCARD_DEVICE_SUCCESS,
  LINK_SIMCARD_DEVICE_ERROR,
  UNLINK_SIMCARD_DEVICE,
  UNLINK_SIMCARD_DEVICE_SUCCESS,
  UNLINK_SIMCARD_DEVICE_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/simcard';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.simcard;
const simcard = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullSimcard') {
        return {
          ...state,
          current: { ...initialSettings.current },
          add: { ...initialSettings.add },
          import: { ...initialSettings.import },
          update: { ...initialSettings.update },
          linkDevice: { ...initialSettings.linkDevice },
          synchronize: { ...initialSettings.synchronize },
          activate: { ...initialSettings.activate },
        };
      }
      switch (action.target) {
        case 'currentSimcard':
          key = 'current';
          break;
        case 'addSimcards':
          key = 'add';
          break;
        case 'importSimcards':
          key = 'import';
          break;
        case 'updateSimcard':
          key = 'update';
          break;
        case 'linkSimcardDevice':
          key = 'linkDevice';
          break;
        case 'synchronizeSimcards':
          key = 'synchronize';
          break;
        case 'activateSimcards':
          key = 'activate';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST
    case GET_SIMCARDS_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case GET_SIMCARDS_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case GET_SIMCARDS_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.data),
            pageNumber: _parseInt(action.data.page_number),
            pageSize: _parseInt(action.data.page_size),
            totalEntries: _parseInt(action.data.total_entries),
            totalPages: _parseInt(action.data.total_pages),
          },
        },
      };
    // ADD
    case ADD_SIMCARDS:
      return {
        ...state,
        add: {
          ...state.add,
          error: null,
          added: false,
          nbAdded: 0,
        },
      };
    case ADD_SIMCARDS_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case ADD_SIMCARDS_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
          nbAdded: action.data.data.length,
        },
      };
    // IMPORT
    case IMPORT_SIMCARDS:
      return {
        ...state,
        import: {
          ...state.import,
          loading: true,
          result: null,
          error: null,
        },
      };
    case IMPORT_SIMCARDS_ERROR:
      return {
        ...state,
        import: {
          ...state.import,
          loading: false,
          error: action.error,
        },
      };
    case IMPORT_SIMCARDS_SUCCESS:
      return {
        ...state,
        import: {
          ...state.import,
          loading: false,
          result: action.data,
        },
      };
    // GET
    case GET_SIMCARD:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_SIMCARD_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_SIMCARD_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.data),
        },
      };
    // UPDATE
    case UPDATE_SIMCARD:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
        },
      };
    case UPDATE_SIMCARD_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_SIMCARD_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };
    // SYNCHRONIZE
    case SYNCHRONIZE_SIMCARDS:
      return {
        ...state,
        synchronize: {
          ...state.synchronize,
          done: false,
          error: null,
        },
      };
    case SYNCHRONIZE_SIMCARDS_ERROR:
      return {
        ...state,
        synchronize: {
          ...state.synchronize,
          error: action.error,
        },
      };
    case SYNCHRONIZE_SIMCARDS_SUCCESS:
      return {
        ...state,
        synchronize: {
          ...state.synchronize,
          done: true,
          error: null,
        },
      };
    // ACTIVATE
    case ACTIVATE_SIMCARDS:
      return {
        ...state,
        activate: {
          ...state.activate,
          done: false,
          error: null,
        },
      };
    case ACTIVATE_SIMCARDS_ERROR:
      return {
        ...state,
        activate: {
          ...state.activate,
          error: action.error,
        },
      };
    case ACTIVATE_SIMCARDS_SUCCESS:
      return {
        ...state,
        activate: {
          ...state.activate,
          done: true,
          error: null,
        },
      };
    // LINK/UNLINK DEVICE
    case LINK_SIMCARD_DEVICE:
    case UNLINK_SIMCARD_DEVICE:
      return {
        ...state,
        linkDevice: {
          ...state.linkDevice,
          done: false,
          error: null,
        },
      };
    case LINK_SIMCARD_DEVICE_ERROR:
    case UNLINK_SIMCARD_DEVICE_ERROR:
      return {
        ...state,
        linkDevice: {
          ...state.linkDevice,
          error: action.error,
        },
      };
    case LINK_SIMCARD_DEVICE_SUCCESS:
    case UNLINK_SIMCARD_DEVICE_SUCCESS:
      return {
        ...state,
        linkDevice: {
          ...state.linkDevice,
          done: true,
        },
      };
    default:
      return state;
  }
};

export default simcard;



// WEBPACK FOOTER //
// ./reducers/simcard/simcard.js